import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';

const customStyles = {
    option: (styles, {isSelected, isFocused}) => ({
        ...styles,
        color: isSelected ? '#fff' : isFocused ? '#fff' : '#333',
        opacity: isFocused ? 0.8 : 1,
        backgroundColor: isSelected ? '#ad1a5f' : isFocused ? '#ad1a5f' : '#fff',
        fontSize:'12px',
    })
};

const Container = styled.div`
    display: ${props => props.inline ? 'flex' : ''};
    align-items: center;
`;

const Label = styled.p`
    white-space: nowrap;
    color: #333;
`;

const DynamicContent = styled.p`
    color: #333;
    margin: 4px 0 0 0;
    font-size: 14px;
    white-space: nowrap;
`;

const SelectContainer = styled.div`
    width: -webkit-fill-available;
    .css-yk16xz-control, .css-1pahdxg-control{
        border: 1px solid #2d207d;
        box-shadow: none;
    }
    :hover {
        .css-yk16xz-control{
            border: 1px solid #2d207d;
        }
    }
    :hover {
        .css-1pahdxg-control{
            border: 1px solid #ad1a5f !important;
            box-shadow: none;
        }
    }
`;

const DropDown = ({label, ddClassName, onChange, value, inline, dynamic, required, options, disabled, placeholder, isSearchable = false}) => (
    <Container inline={inline} className={ddClassName ? ddClassName : "mb-3"}>
        {label && <Label className="mb-1">{label}{required && <span style={{color: 'red', marginLeft: '2px'}}>*</span>}</Label>}
        <SelectContainer>
            {(value && value.label) ? <Select isSearchable={isSearchable} value={value} isDisabled={disabled} styles={customStyles} placeholder={placeholder} name={label} options={options} onChange={(value) => onChange(value)} />
            : <Select isSearchable={isSearchable} value={value} isDisabled={disabled} styles={customStyles} placeholder={(placeholder && placeholder.length > 0) ? placeholder : `Select the ${label}`} name={label} options={options} onChange={(value) => onChange(value)} />}
        </SelectContainer>
        {dynamic && <DynamicContent>Options will render dynamically</DynamicContent>}
    </Container>
);

export default DropDown;